import React from 'react';
import classes from './tabsV2.module.scss';

function TabsV2(props) {
  const { tabs, currentTab, setTab, withDivider = true } = props;

  const changeTab = (tab) => {
    setTab(tab);
  };

  return (
    <div className={classes.container}>
      <div className={classes.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab.value}
            role="presentation"
            className={`${tab.value !== currentTab ? '' : classes.active} ${classes.tab}`}
            onClick={() => changeTab(tab)}
          >
            {tab.icon}
            {tab.title}{' '}
            {(tab?.badgeText || tab?.badgeText === 0) && <span className={classes.count}>{tab.badgeText}</span>}{' '}
          </div>
        ))}
      </div>
      {withDivider && <hr className={classes.divider} />}
    </div>
  );
}

export default TabsV2;
